import React from 'react'
// import loadable from '@loadable/component'
import {
  SEO,
  VideoHero,
  TestimonialsSection,
  MeetKatalystSection,
  ElevateYourFitnessSection,
  BuiltToFitYourLifeSection,
  PromoSection,
  // FinancingSection,
} from '../components'

// const LetsGetStartedSection = loadable(() =>
//   import('../components/sections/lets-get-started-section')
// )

const HomePage = () => (
  <>
    <SEO title="Home Page" />
    <VideoHero />
    <TestimonialsSection />
    <MeetKatalystSection />
    <ElevateYourFitnessSection />
    <BuiltToFitYourLifeSection />
    <PromoSection />
    {/* <FinancingSection /> */}
    {/* <LetsGetStartedSection /> */}
  </>
)

export default HomePage
